'use client';
// External libs
import React from 'react';

// Lib
import { Autocomplete as MuiAutocomplete } from '@mui/material';
import { AutocompleteProps } from './autocomplete.Interfaces';
import { PaperStyled } from './autocomplete-styles';

function Autocomplete<
  T,
  Multiple extends boolean | undefined = undefined,
  DisableClearable extends boolean | undefined = undefined,
  FreeSolo extends boolean | undefined = undefined
>(props: AutocompleteProps<T, Multiple, DisableClearable, FreeSolo>): JSX.Element {
  const template: JSX.Element = (
    <MuiAutocomplete
      fullWidth={true}
      noOptionsText="Aucun résultat"
      loadingText="Recherche en cours..."
      PaperComponent={PaperStyled}
      {...props}
    />
  );

  return template;
}

export default Autocomplete;
